<div [ngClass]="{ 'emma-timeago': true, disabled: disabled }">
    <div class="input-group">
        <emma-select
            [items]="availableUnits"
            [ngModel]="selectedUnit"
            (ngModelChange)="onUnitChange($event)"
            [searchable]="false"
            [disabled]="disabled"
            [readonly]="readonly"
            [color]="color"
            ($blur)="onBlur()"
        ></emma-select>
        <div class="input-group-text input-group-text-transparent input-group-slider-sibling">
            <span>{{ sliderValue | i18nPlural: unitsMapping[selectedUnit] }}</span>
        </div>
        <div class="input-group-slider">
            <ngx-slider
                class="emma-ngx-slider-brand"
                [(value)]="sliderValue"
                (userChange)="onSliderContextChange($event)"
                (userChangeEnd)="onBlur()"
                [options]="sliderOptions"
            ></ngx-slider>
        </div>
    </div>
</div>
